import { h, VNode } from "vue";

export function wrapEditorInSsrNode(
  editor: VNode,
  placeholders: VNode[],
  ssrTemplate: string | null,
  selector: string
) {
  if (!ssrTemplate) return editor;

  const parser = new DOMParser();
  const doc = parser.parseFromString(ssrTemplate, "text/html");

  const getParentElements = (element: Element) => {
    const parents = [];
    let current: Element | null = element.parentElement;

    while (current && current.tagName.toLowerCase() !== "body") {
      parents.push({
        tag: current.tagName.toLowerCase(),
        className: current.className || ""
      });
      current = current.parentElement;
    }

    return parents;
  };

  const element = doc.querySelector(selector);

  if (!element) return editor;

  const parents = getParentElements(element);

  const Wrapper = element.tagName.toLowerCase();
  const WrappedItem = h(Wrapper, { class: element.className }, [editor]);

  // Reduce parents to nested elements
  return parents.reverse().reduceRight(
    (child: VNode | VNode[], parent) => {
      const Wrapper = parent.tag.toLowerCase();
      return h(
        Wrapper,
        { class: parent.className },
        Array.isArray(child) ? child : [child]
      );
    },
    [WrappedItem, ...placeholders] as VNode[]
  );
}

export function getSsrNodePlaceholders(
  ssrTemplate: string | null,
  selector: string
) {
  if (!ssrTemplate) return [];

  const parser = new DOMParser();
  const doc = parser.parseFromString(ssrTemplate, "text/html");
  const elements = doc.querySelectorAll(selector);

  if (!elements) return [];

  return Array.from(elements)
    .slice(1) // Ignore the first element
    .map(element => {
      return {
        tag: element.tagName.toLowerCase(),
        className: element.className || "",
        innerHTML: element.innerHTML
      };
    });
}

export function createSsrPlaceholders(
  placeholders: Array<{
    tag: string;
    className: string;
    innerHTML: string;
  }>
) {
  return placeholders.map((placeholder, i) => {
    const Wrapper = placeholder.tag;
    return h(Wrapper, {
      key: `placeholder-${i}`,
      class: `breakdance-inline-editor-placeholder ${placeholder.className}`,
      domProps: { innerHTML: placeholder.innerHTML }
    });
  });
}
